import { render, staticRenderFns } from "./BasicUpdateForm.vue?vue&type=template&id=def84646&scoped=true"
import script from "./BasicUpdateForm.vue?vue&type=script&lang=js"
export * from "./BasicUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./BasicUpdateForm.vue?vue&type=style&index=0&id=def84646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def84646",
  null
  
)

export default component.exports